import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";

export default class PurchaseOrderService extends ApiService {
  namespace = "purchaseOrder";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "PO";
  DOMAIN = DOMAIN.PURCHASE_ORDER;
  data = [];
  favicon = "Bullets";
  name = "Prchase Order";
  showLeftBar = false;
  singular = this.terminology.purchaseOrder.singular;
  plural = this.terminology.purchaseOrder.plural;
  vowel = this.terminology.purchaseOrder.vowel;
  layout = 2;
  Width = 1500;
  gemItems = [
    {
      key: "listing",
      label: "All Purchase Orders - POs",
      icon: "Bullets",
    },
    {
      key: "create",
      label: "Add a Purchase Orders - PO",
      icon: "Plus",
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: "Shred",
      field: "number",
      width: "5",
    },
    {
      header: this.t("customer"),
      icon: "UserSilhouette",
      field: "customer",
    },
    {
      header: this.t("date"),
      icon: "GreenCalendar",
      field: "date",
      width: "5",
      template: (data) => {
        return moment.unix(data.date).format("MM/DD/YYYY").format("MM/DD/YYYY");
      },
    },
    {
      header: this.t("due"),
      icon: "Lightning",
      field: "due_date",
      width: "5",
    },

    {
      header: this.t("amount"),
      icon: "Money",
      field: "amount",
      width: "5",
    },

    {
      header: this.t("received"),
      icon: "Money",
      field: "received",
      width: "5",
    },
    {
      header: this.t("balance"),
      icon: "Money",
      field: "balanace",
      width: "5",
    },
    {
      header: this.t("status"),
      icon: "Lightning",
      field: "status",
      width: "5",
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      // icon: PrimeIcons.FOLDER,
      icon: "Folder",
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      // icon: PrimeIcons.FILE,
      icon: "Preview",
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      // icon: PrimeIcons.PRINT,
      icon: "Printer",
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      // icon: PrimeIcons.ENVELOPE,
      icon: "Mail",
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      // icon: PrimeIcons.LIST,
      icon: "Layout",
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: "Disable",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit this Invoice...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCE,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  invoiceData = {
    ar_account: "2",
    billing_address: "this is billing address",

    customer: "2",

    customer_message: "this is customer message",

    date: "2022-01-31",
    delivery_address: "this is delivery address",

    delivery_date: "2",

    delivery_method: "2",

    delivery_tracking_number: "2221",

    due_date: "2022-01-31",

    incoterms: "3",

    incoterms_point: "this is incoterms point table",

    is_approved: "0",

    is_draft: "0",

    is_tba: "0",
    is_template: "0",

    job: "2",
    layout: "2",

    number: "2101",
    purchase_order_number: "112211",

    sales_rep: "2101",

    sales_rep_type: "17",

    tax: "2101",

    template: "2101",

    terms: "1",

    total_amount: "2101",
  };

  constructor() {
    super("purchase-orders");
  }
}
